module.exports = __webpack_public_path__ + "img/home copy.f4cd8cbf.png";